import { fetchTranslation } from '../../../helpers/i18n';

const MISSING_TRANSLATION_PREFIX = '[Missing Translation]';

// state_label / zip_label come from config/countries.yml as English words
// ("Province", "Canton", "State/Territory"). Translate them by normalized key
// and fall back to the raw English string when the locale has no entry — so a
// country whose label is "Province" doesn't get masked by the generic "state"
// translation.
function translateCountryLabel(label, defaultKey) {
  if (!label) return fetchTranslation(defaultKey);

  const key = label.toLowerCase().replace(/[\s/]+/g, '_');
  const translation = fetchTranslation(key);
  return translation.startsWith(MISSING_TRANSLATION_PREFIX) ? label : translation;
}

// Derives the country-aware label/option set used by the sharing Create Account
// and gate forms. `countries` is the Rails-provided list (or undefined when the
// prop isn't passed — callers should treat a returned `countryList: null` as a
// signal to fall back to their own dropdown source).
export function getCountryFields(countries, countryId) {
  const countryList = (countries && countries.length > 0) ? countries : null;
  const selectedCountry = countryList?.find(c => Number(c.code) === Number(countryId));

  return {
    countryList,
    selectedCountry,
    stateLabel: translateCountryLabel(selectedCountry?.stateLabel, 'state'),
    zipLabel: translateCountryLabel(selectedCountry?.zipLabel, 'zip'),
    stateIsEnum: selectedCountry?.stateType === 'enum',
    stateOptions: selectedCountry?.stateOptionsForSelect || [],
    showZip: selectedCountry ? selectedCountry.hasZip !== false : true
  };
}
